import React, { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { GraphUp, Person, Image, ChevronLeft, ChevronRight } from 'react-bootstrap-icons'
import SidebarLinks from '../../../../ProjectManager/Campaign/CampaignPageParts/SIdebarParts/SidebarLinks'
import { useSidebarCollapse } from '../../../../../contexts/SidebarCollapseContext'

export default function AuthenticationSidebar() {
  const [activePath, setActivePath] = useState('')
  const { isCollapsed, toggleCollapse } = useSidebarCollapse()
  let location = useLocation()
  const { id, authentication_id, campaign_authentication_id } = useParams()

  const paths = {
    overview: 'overview',
    statistics: 'statistics',
    social_posts: 'social_posts',
  }

  const updateSelectedPath = () => {
    const currentPath = Object.keys(paths).find(path => location.pathname.includes(path))
    setActivePath(paths[currentPath] || 'overview')
  }

  useEffect(() => updateSelectedPath(), [location.pathname])

  const basePath = `/advertiser/campaign_share/${id}/influencers/campaign_authentications/${campaign_authentication_id}/authentication/${authentication_id}`

  return (
    <div className={`fixed ${isCollapsed ? 'w-16' : 'w-56'} bg-white dark:bg-rb-dark-mode border-r-1 dark:border-rb-dark-mode-lighter pt-4 h-full transition-all duration-300 left-0 z-10`}>
      {!isCollapsed && (
        <div className="px-4 flex items-center justify-between">
          <p className="text-xs text-gray-300 dark:text-gray-400 uppercase">Influencer details</p>
          <button
            onClick={toggleCollapse}
            className="p-1 rounded-md hover:bg-gray-200 dark:hover:bg-rb-dark-mode-lighter dark:text-white"
            title="Összecsukás"
          >
            <ChevronLeft className="text-sm" />
          </button>
        </div>
      )}
      {isCollapsed && (
        <div className="px-2 flex items-center justify-center py-2">
          <button
            onClick={toggleCollapse}
            className="p-1 rounded-md hover:bg-gray-200 dark:hover:bg-rb-dark-mode-lighter dark:text-white"
            title="Kinyitás"
          >
            <ChevronRight className="text-sm" />
          </button>
        </div>
      )}
      <SidebarLinks text="Overview" icon={<Person/>} link={`${basePath}/overview`} active={activePath === "overview"} />
      <SidebarLinks text="Statistics" icon={<GraphUp />} link={`${basePath}/statistics`} active={activePath === "statistics"} />
      <SidebarLinks text="Social Posts" icon={<Image/>} link={`${basePath}/social_posts`} active={activePath === "social_posts"} />
    </div>
  )
}

